import React from 'react';
import './scss/full-screen-loader.scss';
import { Button, Modal } from 'react-bootstrap';
import ConfirmDialogProp from './properties/confirm-dialog';

function ConfirmDialog({
  title, message, show, onHide, data, handleYes,
}:ConfirmDialogProp): React.ReactElement {
  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title id="contained-modal-title-vcenter">
          <h5>Confirmation!</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>{title}</h6>
        <p style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
          {message}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => handleYes(data)}>
          Yes
        </Button>
        <Button variant="primary" onClick={onHide}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmDialog;
